import React, { useState, useEffect, forwardRef } from "react";

export default function withStripe(Component, FallbackComponent = () => null) {
    const publishableKey = window.stripePublishableKey;

    return forwardRef(function ComponentWithStripe(props, ref) {
        const [stripe, setStripe] = useState(window.Stripe ? window.Stripe(publishableKey) : null);

        useEffect(() => {
            if (stripe) {
                // Already loaded
                return;
            }

            // Wait for stripe-js script to load
            const stripeJs = document.querySelector("#stripe-js");
            if (!stripeJs) {
                throw new Error("Missing stripe-js script");
            }

            stripeJs.addEventListener("load", () => {
                setStripe(window.Stripe(publishableKey));
            });
        }, []);

        if (!stripe) {
            return <FallbackComponent />;
        }

        return <Component {...props} stripe={stripe} ref={ref} />;
    });
}
